function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  id: "arrow",
  d: "M1.815 49.823c-.018.436.262.686.663.853.93.387 1.857.779 2.785 1.168l10.143 4.249 8.616 3.6a.907.907 0 0 0 1.236-1.212q-1.317-3.438-2.643-6.875c-.2-.523-.411-1.042-.6-1.572a.766.766 0 0 1 0-.482c.775-2.045 1.563-4.086 2.348-6.127.3-.774.6-1.546.891-2.321a.917.917 0 0 0-.183-1.066A.937.937 0 0 0 24 39.9L7.242 46.917l-4.595 1.92c-.12.051-.238.108-.354.167a.835.835 0 0 0-.478.819zm21 7.357l-.046.048-15.4-6.446.017-.069h12.553c.412 0 .412.005.562.4l2.229 5.8c.034.087.056.177.083.267zm-15.428-8.3l-.018-.07 15.4-6.447a.418.418 0 0 1-.014.252l-2.265 5.884c-.148.383-.151.382-.572.382H7.385z",
  className: "cls-1",
  transform: "translate(-1.814 -39.795)"
});
const SvgArrow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23.536,
  height: 20,
  viewBox: "0 0 23.536 20",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.01bcc22b.svg";
export { ForwardRef as ReactComponent };